// extracted by mini-css-extract-plugin
export default {"contactCtn":"ContactItem_contactCtn__kSGKs","contactData":"ContactItem_contactData__mhQs7","btnContact":"ContactItem_btnContact__2ljeB"};